import type { UseQueryResult } from '@tanstack/react-query';
import type { ThirdPartyInvoicingContents } from '../types/thirdPartyAgreement.types';

type InvoicingQueryState = Pick<UseQueryResult<ThirdPartyInvoicingContents>, 'isError' | 'data'>;

/** The tabpanel is a tab stop only while its body holds nothing focusable. */
export const isThirdPartyInvoicingPanelFocusable = ({ isError, data }: InvoicingQueryState): boolean => {
    if (isError) return false;
    if (!data) return true;

    return data.services.length === 0 && data.addOns.length === 0;
};
